export function normalizePermissionArgs(args) {
  if (Array.isArray(args) && args.length === 1 && Array.isArray(args[0])) {
    return args[0].filter(Boolean);
  }

  if (Array.isArray(args)) {
    return args.filter(Boolean);
  }

  return [];
}

export function getUserPermissions(user) {
  return Array.isArray(user?.permissions) ? user.permissions : [];
}

export function hasPermission(user, permission) {
  if (!permission) return false;
  return getUserPermissions(user).includes(permission);
}

export function hasAnyPermission(user, ...permissions) {
  const requestedPermissions = normalizePermissionArgs(permissions);
  if (requestedPermissions.length < 1) return false;

  const userPermissions = getUserPermissions(user);
  return requestedPermissions.some((permission) =>
    userPermissions.includes(permission)
  );
}

export function hasAllPermissions(user, ...permissions) {
  const requestedPermissions = normalizePermissionArgs(permissions);
  if (requestedPermissions.length < 1) return false;

  const userPermissions = getUserPermissions(user);
  return requestedPermissions.every((permission) =>
    userPermissions.includes(permission)
  );
}
